import Todo from '../Components/Todo';
import { auth } from '../Utils/firebaseConfig'
import { useState } from 'react';

import './Todo.css';

const TodoView = () => {
  const [isLoggedin, setIsLoggedIn] = useState(false)

  auth.onAuthStateChanged((user) => {
    if (user) {
      setIsLoggedIn(!!user);
    } else {
      window.location.href = '/'
    }
  });
  return (
    <div
      style={{
        height: 'calc(100vh - 64px)', // fill viewport below fixed header
        overflow: 'auto',
        boxSizing: 'border-box',
      }}
    >
      {isLoggedin ? <Todo /> : <></>}
    </div>
  );
}

export default TodoView;
